import {Component, Input} from '@angular/core';
import {AbstractComponent} from "@components";
import {
  ImportConfirmation,
  ListSortOrder,
  PagedFilter,
  Pages,
  StatementFileImport,
  StatementImport,
  StatementImportFilter,
  TOAST_STATE
} from "@model";
import {AccountStatementsService, LoaderService, ToastService} from "@services";
import {environment} from "@environment";
import {TranslocoService} from "@ngneat/transloco";
import {DETAILS} from "../../../../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import dayjs from "dayjs";
import {ImportStatus} from "../../../../../model/statements/import-status";

@Component({
  selector: 'app-list-of-account-statements',
  templateUrl: './list-of-account-statements.component.html',
  styleUrls: ['./list-of-account-statements.component.scss']
})
export class ListOfAccountStatementsComponent extends AbstractComponent {
  @Input() accountStatements: StatementImport[] = [];

  constructor(private toastService:ToastService, private translocoService:TranslocoService, private router: Router,
              private accountStatementsService:AccountStatementsService, private loaderService:LoaderService,
              private route: ActivatedRoute) {
    super();
  }
  processFile(fileInput: any): void {
    if (fileInput.files?.length > 0) {
      const file: File = fileInput.files[0];
      if (file.size > environment.maxFileSize) {
        this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate("app.user.profile.max.size.error"));
      } else {
        const reader: FileReader = new FileReader();
        reader.addEventListener('load', (event: any) => {
          let fileContent = event.target.result as string;

          const [dataType, base64Content] = fileContent.split(",");
          const isSigned = dataType.includes('octet-stream');

          let content = `data:text/xml;base64,${base64Content}`;

          let startDate = dayjs().add(-1, 'years');
          let endDate = dayjs().add(1, 'years');
          this.loaderService.startLoading();
          this.accountStatementsService.uploadStatementFileImport(new StatementFileImport(file.name, content), isSigned, () => {
            this.accountStatementsService.findImports(new PagedFilter(new Pages(), new StatementImportFilter(startDate.toDate(), endDate.toDate()), ListSortOrder.DESC)).subscribe((accountStatements: StatementImport[]) => {
              this.accountStatements = accountStatements;
              this.loaderService.dismissLoading();
              this.toastService.showToast(TOAST_STATE.success,
                this.translocoService.translate("account.statements.upload.success"));
            });
          }, () => {
            this.loaderService.dismissLoading();
            this.toastService.showToast(TOAST_STATE.danger,
              this.translocoService.translate("account.statements.upload.error"));
          });
        });
        reader.readAsDataURL(file);
      }
    }
  }

  goToAccountStatementDetails(statementImport:StatementImport): void {
    if (statementImport && statementImport.id) {
      this.router.navigate([DETAILS], {queryParams: {importId: statementImport.id}, relativeTo:this.route});
    }
  }

  deleteAccountStatement(statementImport:StatementImport):void {
    let importConfirmation: ImportConfirmation = new ImportConfirmation(statementImport!.id!, []);
    this.loaderService.startLoading();
    this.accountStatementsService.deleteImport(importConfirmation, () => {
      let startDate = dayjs().add(-1, 'years');
      let endDate = dayjs().add(1, 'years');
      this.accountStatementsService.findImports(new PagedFilter(new Pages(), new StatementImportFilter(startDate.toDate(), endDate.toDate()), ListSortOrder.DESC)).subscribe((accountStatements: StatementImport[]) => {
        this.accountStatements = accountStatements;
        this.loaderService.dismissLoading();
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("account.statements.delete.success"));
      });
    }, () => {
      this.loaderService.dismissLoading();
      this.toastService.showToast(TOAST_STATE.danger,
        this.translocoService.translate("account.statements.delete.error"));
    });
  }

  protected readonly ImportStatus = ImportStatus;
}
